export const formContent2 = 'parts: {0} machine: 0';
export const federatedSearchFormContent2 =
  'parts: {0} machine: 0 parts diagrams: {1}';
export const formName = 'search results';
export const PCC_SEARCH_RESULTS = 'PCC Search Results';
export const PCC_SEARCH_RESULTS_PAGE = 'PCC Search Results Page';
export const DATA_TRACK_SEARCH_RESULTS = {
  EVENT: 'e_primaryCTA',
  NL_TEXT_QUICK_ORDER: 'quick order',
  NL_TEXT_SIGN_IN: 'sign in',
  CONTEXT: 'search results section'
};
